// src/components/FreeTierBanner.js
//
// Drop this at the top of any page that trims its content for free users, so
// the trimming reads as "there's more here" rather than "this looks broken."
//
//   import FreeTierBanner from "../components/FreeTierBanner";
//   import useAccessLevel, { limitList } from "../hooks/useAccessLevel";
//
//   const { isFree, contentLimit } = useAccessLevel();
//   const visible = limitList(topics, contentLimit);
//   ...
//   <FreeTierBanner hiddenCount={topics.length - visible.length} />

import React from "react";
import { Link } from "react-router-dom";
import useAccessLevel from "../hooks/useAccessLevel";

export default function FreeTierBanner({ hiddenCount = 0, label = "tools" }) {
  const { isFree, trialEnded } = useAccessLevel();
  if (!isFree) return null;

  return (
    <div style={s.wrap}>
      <div style={s.text}>
        {trialEnded ? (
          <>
            <strong>Your free trial has ended.</strong> Your dashboard, avatar and items are all still yours, with the
            first 3 topics of each subject.{" "}
            {hiddenCount > 0 ? `${hiddenCount} more ${label}, ` : "Every topic, "}
            coins and progress tracking come back with a plan.
          </>
        ) : (
          <>
        <strong>You're on the free plan.</strong>{" "}
        {hiddenCount > 0
          ? `${hiddenCount} more ${label} unlock with a subscription.`
          : `Subscribe to unlock every ${label.replace(/s$/, "")}, classroom tools, and progress tracking.`}
          </>
        )}
      </div>
      <Link to="/choose-plan" style={s.cta}>
        See plans
      </Link>
    </div>
  );
}

const s = {
  wrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
    flexWrap: "wrap",
    padding: "12px 16px",
    borderRadius: 10,
    margin: "0 0 16px",
    background: "linear-gradient(90deg, rgba(225,0,255,0.10), rgba(127,0,255,0.10))",
    border: "1px solid rgba(127,0,255,0.25)",
  },
  text: {
    fontSize: "clamp(0.82rem, 2vw, 0.95rem)",
    color: "#3b0764",
    lineHeight: 1.5,
    flex: "1 1 240px",
  },
  cta: {
    padding: "8px 16px",
    borderRadius: 7,
    background: "linear-gradient(90deg, #e100ff, #7f00ff)",
    color: "#fff",
    fontSize: 14,
    fontWeight: 700,
    textDecoration: "none",
    whiteSpace: "nowrap",
  },
};
